/*
 * main-product.js — Selena Theme 
 */
(function () {
  'use strict';
 

  function waitForSwiper(callback, attempts) {
    attempts = attempts || 0;
    if (window.Swiper) {
      callback();
      return;
    }
    if (attempts >= 30) return;
    setTimeout(function () {
      waitForSwiper(callback, attempts + 1);
    }, 100);
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var formatString = format || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    var value = '';
    var match = formatString.match(placeholderRegex);
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Play/pause an embedded YouTube/Vimeo player via postMessage.  */
  function controlExternalVideo(iframe, action) {
    var src = iframe.src || '';
    var win = iframe.contentWindow;
    if (!win) return;
    if (iframe.dataset.playerReady !== 'true') {
      iframe.dataset.pendingCommand = action;
    } 
    iframe.dataset.playing = action === 'play' ? 'true' : 'false';
    try {
      if (src.indexOf('youtube.com') > -1 || src.indexOf('youtube-nocookie.com') > -1) {
        win.postMessage(
          JSON.stringify({
            event: 'command',
            func: action === 'play' ? 'playVideo' : 'pauseVideo',
            args: [],
          }),
          '*'
        );
      } else if (src.indexOf('vimeo.com') > -1) {
        win.postMessage(JSON.stringify({ method: action }), '*');
      }
    } catch (error) {
      /* cross-origin hiccup — ignore */
    }
  }

  function playHostedVideo(video) {
    video.muted = true;
    var playing = video.play();
    if (playing && playing.catch) playing.catch(function () {});
  }

  var playerUid = 0;

  /* ── <main-product> ──────────────────────────────────────── */

  class MainProduct extends HTMLElement {
    connectedCallback() {
      this._onVariantChange = this._onVariantChange || this.handleVariantChange.bind(this);
      this._onClick = this._onClick || this.handleClick.bind(this);
      this._onSubmitGuard = this._onSubmitGuard || this.handleSubmitGuard.bind(this);
      this.addEventListener('variant:change', this._onVariantChange);
      this.addEventListener('click', this._onClick);
      this.addEventListener('submit', this._onSubmitGuard);

      this.initPickupRefresh();
    }

   
    initPickupRefresh() {
      if (window.Shopify && window.Shopify.designMode) return;
      var container = this.querySelector('[data-pickup-container][data-pickup-refresh]');
      if (!container || container.children.length > 0) return;
      if (new URLSearchParams(window.location.search).has('variant')) return;

      var info = this.querySelector('.product-info');
      var variantId = info && info.getAttribute('data-variant-id');
      if (variantId) this.updatePickup({ id: variantId });
    }

   
    handleSubmitGuard(event) {
      var submitter = event.submitter;
      if (!submitter) return;  
      if (submitter.name === 'add') return;
      if (submitter.closest('.shopify-payment-button')) return;
      event.preventDefault();
    }

    disconnectedCallback() {
      this.removeEventListener('variant:change', this._onVariantChange);
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('submit', this._onSubmitGuard);
      if (this._pickupController) this._pickupController.abort();
      if (this._switchController) this._switchController.abort();
      clearTimeout(this._pickupTimer);
    }

    handleVariantChange(event) {
      var variant = event.detail ? event.detail.variant : null;
      this.clearBuyError();
      this.updateIdInput(variant);
      this.resetQuantity();
      this.updateQuantityMax(variant);
      this.updatePrice(variant);
      this.updateInventory(variant);
      this.updateStockBar(variant);
      this.updateSku(variant);
      this.updateBuyButtons(variant);
      this.updateGallery(variant);
      this.updateUrl(variant);
      this.updatePickup(variant);

      var info = this.querySelector('.product-info');
      if (info && variant) info.setAttribute('data-variant-id', variant.id);

      document.dispatchEvent(
        new CustomEvent('product:variant-changed', {
          detail: { variant: variant, sectionId: this.dataset.sectionId },
        })
      );
    }

    updateIdInput(variant) {
      var form = this.getBuyForm();
      var input = form && form.querySelector('[data-variant-id-input]');
      if (!input) return;
      if (variant) {
        input.value = variant.id;
        input.disabled = false;
        input.dataset.inventoryQuantity = variant.inventory_quantity;
        input.dataset.inventoryTracked =
          variant.inventory_management && variant.inventory_policy !== 'continue'
            ? 'true'
            : 'false';
      } else {
        input.disabled = true;
      }
    }

    resetQuantity() {
      // Quick view only: keep whatever the shopper typed on the main product page
      if (this.dataset.view !== 'quick-view') return;
      var form = this.getBuyForm();
      var input = form && form.querySelector('quantity-input input[name="quantity"]');
      if (input) input.value = 1;
    }

    updateQuantityMax(variant) {
      var form = this.getBuyForm();
      var input = form && form.querySelector('quantity-input input[name="quantity"]');
      if (!input) return;
      var tracked =
        variant && variant.inventory_management && variant.inventory_policy !== 'continue';
      if (tracked && variant.inventory_quantity > 0) {
        input.max = variant.inventory_quantity;
        if ((parseInt(input.value, 10) || 1) > variant.inventory_quantity) {
          input.value = variant.inventory_quantity;
        }
      } else {
        input.removeAttribute('max');
      }
    }

    updatePrice(variant) {
      if (!variant) return;
      var format = this.dataset.moneyFormat;
      var current = this.querySelector('[data-price-current]');
      var compare = this.querySelector('[data-price-compare]');
      var badge = this.querySelector('[data-price-badge]');
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

      if (current) {
        current.textContent = formatMoney(variant.price, format);
        current.classList.toggle('product-price__current--sale', !!onSale);
      }
      if (compare) {
        compare.hidden = !onSale;
        compare.textContent = onSale ? formatMoney(variant.compare_at_price, format) : '';
      }
      if (badge) {
        badge.hidden = !onSale;
        if (onSale) {
          var pct = Math.round(
            ((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price
          );
          var offTemplate = badge.dataset.textOff || '[[p]]% OFF';
          badge.textContent = offTemplate.replace('[[p]]', pct);
        }
      }
    }

    updateInventory(variant) {
      var el = this.querySelector('[data-product-inventory]');
      if (!el) return;
      if (!variant || !variant.inventory_management) {
        el.hidden = true;
        return;
      }

      var qty = variant.inventory_quantity || 0;
      var threshold = parseInt(el.dataset.threshold, 10) || 0;
      var showCount = el.dataset.showCount === 'true';
      var state = 'in';
      if (qty <= 0 && variant.inventory_policy !== 'continue') {
        state = 'out';
      } else if (qty > 0 && qty <= threshold) {
        state = 'low';
      }

      var text;
      if (state === 'out') {
        text = el.dataset.textOut;
      } else if (state === 'low') {
        text = showCount
          ? (el.dataset.textLowCount || '').replace('[qty]', qty)
          : el.dataset.textLow;
      } else {
        text = el.dataset.textIn;
      }

      el.hidden = false;
      el.classList.remove('product-inventory--in', 'product-inventory--low', 'product-inventory--out');
      el.classList.add('product-inventory--' + state);
      var textEl = el.querySelector('[data-inventory-text]');
      if (textEl) textEl.textContent = text || '';
    }

    updateStockBar(variant) {
      var el = this.querySelector('[data-product-stock-bar]');
      if (!el) return;
      if (!variant || !variant.inventory_management) {
        el.hidden = true;
        return;
      }

      var qty = variant.inventory_quantity || 0;
      var threshold = parseInt(el.dataset.threshold, 10) || 0;
      var maxStock = parseInt(el.dataset.maxStock, 10) || 0;

      var state = 'in';
      if (qty <= 0) {
        state = variant.inventory_policy === 'continue' ? 'continue' : 'out';
      } else if (qty <= threshold) {
        state = 'low';
      }

      var text;
      if (state === 'out') {
        text = el.dataset.textOut;
      } else if (state === 'continue') {
        text = el.dataset.textContinue;
      } else if (state === 'low') {
        text = (el.dataset.textLow || '').replace('[qty]', qty);
      } else {
        text = (el.dataset.textIn || '').replace('[qty]', qty);
      }

      var fill = 0;
      if (maxStock > 0 && qty > 0) {
        fill = Math.min(100, (qty / maxStock) * 100);
      }

      el.hidden = false;
      el.classList.remove(
        'product-stock-bar--in',
        'product-stock-bar--low',
        'product-stock-bar--continue',
        'product-stock-bar--out'
      );
      el.classList.add('product-stock-bar--' + state);

      var textEl = el.querySelector('[data-stock-bar-text]');
      if (textEl) textEl.textContent = text || '';

      var fillEl = el.querySelector('[data-stock-bar-fill]');
      if (fillEl) fillEl.style.width = fill + '%';

      var track = el.querySelector('[data-stock-bar-track]');
      if (track) {
        track.setAttribute('aria-valuenow', qty);
        track.setAttribute('aria-valuemax', maxStock);
      }
    }

    updateSku(variant) {
      var el = this.querySelector('[data-product-sku]');
      if (!el) return;
      var value = el.querySelector('[data-product-sku-value]');
      var sku = variant ? variant.sku : '';
      el.hidden = !sku;
      if (value) value.textContent = sku || '';
    }

    updateBuyButtons(variant) {
      var addButton = this.querySelector('button[name="add"]');
      var buyNow = this.querySelector('[data-buy-now]');
      var available = !!(variant && variant.available);

      if (addButton) {
        addButton.disabled = !available;
        var label = addButton.querySelector('[data-add-to-cart-text]');
        if (label) {
          if (!variant) {
            label.textContent = addButton.dataset.textUnavailable || '';
          } else if (!available) {
            label.textContent = addButton.dataset.textSoldout || '';
          } else {
            label.textContent = addButton.dataset.textAdd || '';
          }
        }
      }
      if (buyNow) buyNow.disabled = !available;
    }

    updateGallery(variant) {
      var gallery = this.querySelector('product-media-gallery');
      if (gallery && typeof gallery.onVariantChange === 'function') {
        gallery.onVariantChange(variant);
      }
    }

    updateUrl(variant) {
      if (!variant || !this.dataset.url) return;
      if (window.Shopify && window.Shopify.designMode) return;
      try {
        var productPath = new URL(this.dataset.url, window.location.origin).pathname;
        if (productPath !== window.location.pathname) return;
        window.history.replaceState({}, '', this.dataset.url + '?variant=' + variant.id);
      } catch (error) {
        /* URL parsing failed — skip silently */
      }
    }

    updatePickup(variant) {
      var container = this.querySelector('[data-pickup-container]');
      if (!container || !this.dataset.url || !this.dataset.sectionId) return;
 
      var openDialog = container.querySelector('[data-pickup-dialog][open]');
      if (openDialog) openDialog.close();

      clearTimeout(this._pickupTimer);
 
      if (!variant) {
        if (this._pickupController) this._pickupController.abort();
        container.innerHTML = '';
        return;
      }
      this._pickupTimer = setTimeout(
        function () {
          if (this._pickupController) this._pickupController.abort();
          this._pickupController = new AbortController();
          var url =
            this.dataset.url +
            '?variant=' +
            variant.id +
            '&section_id=' +
            this.dataset.sectionId;
          fetch(url, { signal: this._pickupController.signal })
            .then(function (response) {
              return response.text();
            })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var fresh = doc.querySelector('[data-pickup-container]');
              if (fresh) container.innerHTML = fresh.innerHTML;
            })
            .catch(
              function (error) {
                if (error && error.name === 'AbortError') return;
                this.renderPickupError(container, variant);
              }.bind(this)
            );
        }.bind(this),
        200
      );
    }

    renderPickupError(container, variant) {
      var host = container.closest('pickup-availability');
      var message = host && host.dataset.textUnavailable;
      // Without translated strings (older markup) keep the stale preview.
      if (!message) return;

      container.innerHTML = '';
      var status = document.createElement('p');
      status.className = 'product-pickup__error';
      status.setAttribute('role', 'alert');
      status.textContent = message;
      container.appendChild(status);

      var refreshLabel = host.dataset.textRefresh;
      if (refreshLabel) {
        var self = this;
        var refresh = document.createElement('button');
        refresh.type = 'button';
        refresh.className = 'product-pickup__more';
        refresh.textContent = refreshLabel;
        refresh.addEventListener('click', function () {
          self.updatePickup(variant);
        });
        container.appendChild(refresh);
      }
    }

    /*
     * Combined listings: the selected option value belongs to a sibling
     * child product, so re-fetch this section rendered for that product
     * and replace the whole section (media, price, form, description).
     */
    switchProduct(productUrl, ids, focusValueId) {
      if (this._switchController) this._switchController.abort();
      this._switchController = new AbortController();

      var sectionId = this.dataset.sectionId;
      var designMode = window.Shopify && window.Shopify.designMode;
      var wrapper = document.getElementById('shopify-section-' + sectionId);
      if (!wrapper) {
        if (!designMode) window.location.href = productUrl;
        return;
      }

      var addButton = this.querySelector('button[name="add"]');
      if (addButton) {
        addButton.disabled = true;
        addButton.setAttribute('aria-busy', 'true');
      }

      var params = ids.length ? 'option_values=' + ids.join(',') + '&' : '';
      var url = productUrl + '?' + params + 'section_id=' + sectionId;
      if (this.dataset.view) url += '&view=' + this.dataset.view;
      fetch(url, { signal: this._switchController.signal })
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('shopify-section-' + sectionId);
          if (!fresh) {
            if (!designMode) window.location.href = productUrl;
            return;
          }

          // Read the sibling's selected variant before swapping the DOM.
          var dataEl = doc.querySelector('[data-product-data]');
          var payload = dataEl ? JSON.parse(dataEl.textContent) : null;
          var variant = (payload && payload.selected_variant) || null;
  
          var previousRecipient = wrapper.querySelector('gift-recipient');
          var recipientState =
            previousRecipient && typeof previousRecipient.serialize === 'function'
              ? previousRecipient.serialize()
              : null;

          wrapper.innerHTML = fresh.innerHTML;

          if (recipientState) {
            var freshRecipient = wrapper.querySelector('gift-recipient');
            if (freshRecipient && typeof freshRecipient.restore === 'function') {
              freshRecipient.restore(recipientState);
            }
          }

          var target = wrapper.querySelector(
            'input[data-option-value-id="' + focusValueId + '"]'
          );
          if (!target) {
            var opt = wrapper.querySelector(
              'option[data-option-value-id="' + focusValueId + '"]'
            );
            if (opt) target = opt.closest('select');
          }
          if (target) target.focus({ preventScroll: true });

          if (!designMode) {
            var newUrl = variant
              ? productUrl + '?variant=' + variant.id
              : productUrl;
            try {
              window.history.replaceState({}, '', newUrl);
            } catch (error) { 
            }
          }

          document.dispatchEvent(
            new CustomEvent('product:variant-changed', {
              detail: {
                variant: variant,
                sectionId: sectionId,
                productUrl: productUrl,
              },
            })
          );
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return; 
          if (!designMode) {
            window.location.href = productUrl;
          } else if (addButton) {
            addButton.disabled = false;
            addButton.removeAttribute('aria-busy');
          }
        });
    }

    handleClick(event) {
      var buyNow = event.target.closest('[data-buy-now]');
      if (buyNow && !buyNow.disabled) {
        event.preventDefault();
        this.buyNow(buyNow);
      }
    }

    /*
     * The main buy form only. Recommendation widgets (featured items,
     * complementary) inject their own /cart/add forms into this subtree,
     * so unscoped first-match queries can hit the wrong form.
     */
    getBuyForm() {
      return (
        document.getElementById('product-form-' + this.dataset.sectionId) ||
        this.querySelector('form.product-add-to-cart__form') ||
        this.querySelector('form[action*="/cart/add"]') ||
        this.querySelector('form')
      );
    }

    clearBuyError() {
      var productForm = this.querySelector('product-form');
      if (productForm && typeof productForm.clearError === 'function') {
        productForm.clearError();
        return;
      }
      var form = this.getBuyForm();
      var errorEl = form && form.querySelector('[data-buy-buttons-error]');
      if (errorEl) errorEl.hidden = true;
    }

    buyNow(button) {
      var form = this.getBuyForm();
      var productForm = this.querySelector('product-form');
      if (!form) return;

      var addUrl = (productForm && productForm.dataset.cartAddUrl) || '/cart/add';
      this.clearBuyError();

       
      var giftRecipient = this.querySelector('gift-recipient');
      if (giftRecipient && typeof giftRecipient.validate === 'function') {
        if (!giftRecipient.validate()) return;
      }

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      var qtyEl = form.elements ? form.elements.quantity : null;
      var requested = (qtyEl && parseInt(qtyEl.value, 10)) || 1;
      var precheck =
        productForm && typeof productForm.checkInventory === 'function'
          ? productForm.checkInventory(requested)
          : Promise.resolve({ status: 'ok' });

      precheck
        .then(function (check) {
          if (check.status === 'soldout' || check.status === 'max') {
            if (productForm && typeof productForm.showError === 'function') {
              productForm.showError(productForm.inventoryMessage(check));
            }
            button.disabled = false;
            button.removeAttribute('aria-busy');
            return;
          }
          if (check.status === 'partial' && qtyEl) qtyEl.value = check.remaining;

          return fetch(addUrl + '.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
          }).then(function (response) {
            // Error bodies aren't always JSON (e.g. an HTML 404 page).
            return response
              .json()
              .catch(function () {
                return {};
              })
              .then(function (data) {
                if (!response.ok) {
                  data = data || {};
                  data.status = response.status;
                  throw data;
                }
                window.location.href = '/checkout';
              });
          });
        })
        .catch(function (data) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          if (!productForm || typeof productForm.showError !== 'function') return;
          var message = null;
          if (data && !(data instanceof Error)) {
            message =
              typeof productForm.resolveCartError === 'function'
                ? productForm.resolveCartError(data.status, data)
                : typeof data.description === 'string'
                  ? data.description
                  : null;
          }
          var errorEl = productForm.getErrorElement();
          productForm.showError(message || (errorEl && errorEl.dataset.textError));
        });
    }
  }

  if (!customElements.get('main-product')) {
    customElements.define('main-product', MainProduct);
  }

  /* ── <variant-picker> ────────────────────────────────────── */

  class VariantPicker extends HTMLElement {
    connectedCallback() {
      this._onChange = this._onChange || this.handleChange.bind(this);
      this.addEventListener('change', this._onChange);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this._onChange);
      if (this._lookupController) this._lookupController.abort();
    }

    selectedOptions() {
      var options = [];
      this.querySelectorAll('select[data-option-index]').forEach(function (select) {
        options[parseInt(select.dataset.optionIndex, 10)] = select.value;
      });
      this.querySelectorAll('input[type="radio"][data-option-index]:checked').forEach(
        function (input) {
          options[parseInt(input.dataset.optionIndex, 10)] = input.value;
        }
      );
      return options;
    }

     
    selectedOptionValueIds() {
      var ids = [];
      this.querySelectorAll('select[data-option-index]').forEach(function (select) {
        var selected = select.selectedOptions[0];
        ids[parseInt(select.dataset.optionIndex, 10)] =
          (selected && selected.dataset.optionValueId) || null;
      });
      this.querySelectorAll('input[type="radio"][data-option-index]:checked').forEach(
        function (input) {
          ids[parseInt(input.dataset.optionIndex, 10)] = input.dataset.optionValueId || null;
        }
      );
      if (!ids.length) return null;
      for (var i = 0; i < ids.length; i++) {
        if (ids[i] == null) return null;
      }
      return ids;
    }

    handleChange(event) {
      var host = this.closest('main-product');
      var options = this.selectedOptions();

      this.updateSelectedUi(event.target, options);
 
      if (host) {
        var productUrl = this.changedProductUrl(event.target);
        if (productUrl && this.isDifferentProduct(productUrl, host.dataset.url)) {
          this.switchToSibling(host, productUrl, event.target);
          return;
        }
      }

      if (host && host.dataset.url && host.dataset.sectionId) {
        var ids = this.selectedOptionValueIds();
        if (ids) {
          this.resolveVariantRemotely(host, ids, options);
          return;
        }
      }

      this.dispatchVariant(null, options);
    }

    dispatchVariant(variant, options) {
      this.dispatchEvent(
        new CustomEvent('variant:change', {
          bubbles: true,
          detail: { variant: variant, options: options },
        })
      );
    }

    changedProductUrl(target) {
      var el = target;
      if (target.tagName === 'SELECT') el = target.selectedOptions[0];
      return (el && el.dataset.productUrl) || null;
    }

    productHandle(url) {
      try {
        var path = new URL(url, window.location.origin).pathname;
        var match = path.match(/\/products\/([^/]+)\/?$/);
        return match ? match[1] : null;
      } catch (error) {
        return null;
      }
    }

    isDifferentProduct(newUrl, currentUrl) {
      if (!currentUrl) return false;
      var next = this.productHandle(newUrl);
      var current = this.productHandle(currentUrl);
      return !!next && !!current && next !== current;
    }

    switchToSibling(host, productUrl, target) {
      var ids = this.selectedOptionValueIds() || [];
      var el = target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      var focusValueId = (el && el.dataset.optionValueId) || '';

      if (
        host.dataset.productSwap === 'section' &&
        typeof host.switchProduct === 'function'
      ) {
        host.switchProduct(productUrl, ids, focusValueId);
        return;
      } 
      if (window.Shopify && window.Shopify.designMode) return;
      window.location.href = ids.length
        ? productUrl + '?option_values=' + ids.join(',')
        : productUrl;
    }
    resolveVariantRemotely(host, ids, options) {
      if (this._lookupController) this._lookupController.abort();
      this._lookupController = new AbortController();
      var self = this;

      var addButton = host.querySelector('button[name="add"]');
      if (addButton) {
        addButton.disabled = true;
        addButton.setAttribute('aria-busy', 'true');
      }

      var url =
        host.dataset.url +
        '?option_values=' +
        ids.join(',') +
        '&section_id=' +
        host.dataset.sectionId;
      // Alternate-template renders (e.g. quick view) must re-select their
      // template or the section id won't resolve.
      if (host.dataset.view) url += '&view=' + host.dataset.view;
      fetch(url, { signal: this._lookupController.signal })
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          self.refreshPicker(doc);
          var dataEl = doc.querySelector('[data-product-data]');
          var fresh = dataEl ? JSON.parse(dataEl.textContent) : null;
          if (addButton) addButton.removeAttribute('aria-busy');
          self.dispatchVariant((fresh && fresh.selected_variant) || null, options);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          if (addButton) addButton.removeAttribute('aria-busy');
          // Dispatch first — the variant-change handler clears any visible
          // error — then explain that the lookup failed rather than leaving
          // a bare "Unavailable" state.
          self.dispatchVariant(null, options);
          var productForm = host.querySelector('product-form');
          if (productForm && typeof productForm.showError === 'function') {
            var errorEl = productForm.getErrorElement();
            if (errorEl && errorEl.dataset.textError) {
              productForm.showError(errorEl.dataset.textError);
            }
          }
        });
    }

    /*
     * Re-render the option values from the fetched section so each
     * value's availability state stays current for the new selection.
     */
    refreshPicker(doc) {
      var fresh = doc.querySelector('variant-picker');
      if (!fresh) return;

      var active = document.activeElement;
      var focusValueId = null;
      var focusOptionIndex = null;
      if (active && this.contains(active)) {
        if (active.tagName === 'SELECT') {
          focusOptionIndex = active.dataset.optionIndex;
        } else if (active.dataset && active.dataset.optionValueId) {
          focusValueId = active.dataset.optionValueId;
        }
      }

      this.innerHTML = fresh.innerHTML;

      var target = null;
      if (focusValueId) {
        target = this.querySelector('input[data-option-value-id="' + focusValueId + '"]');
      } else if (focusOptionIndex != null) {
        target = this.querySelector('select[data-option-index="' + focusOptionIndex + '"]');
      }
      if (target) target.focus({ preventScroll: true });
    }

    updateSelectedUi(changedInput, options) {
      if (changedInput && changedInput.type === 'radio') {
        var group = changedInput.closest('.variant-picker__option');
        if (group) {
          group.querySelectorAll('.is-selected').forEach(function (el) {
            el.classList.remove('is-selected');
          });
          var label = changedInput.closest('label');
          if (label) label.classList.add('is-selected');
        }
      } 
      this.querySelectorAll('[data-option-value-label]').forEach(function (el) {
        var index = parseInt(el.dataset.optionValueLabel, 10);
        if (options[index] != null) el.textContent = options[index];
      });
    }
  }

  if (!customElements.get('variant-picker')) {
    customElements.define('variant-picker', VariantPicker);
  }

  /* ── <quantity-input> ────────────────────────────────────── */

  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this._onClick = this._onClick || this.handleClick.bind(this);
      this._onChange = this._onChange || this.handleChange.bind(this);
      this.addEventListener('click', this._onClick);
      this.addEventListener('change', this._onChange);
      this.syncButtonHeight();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('change', this._onChange);
      if (this._heightObserver) {
        this._heightObserver.disconnect();
        this._heightObserver = null;
      }
    }

    /* Mirror the add-to-cart button's rendered height into --atc-height so the
       stepper matches it even when .quantity_group wraps onto separate rows. */
    syncButtonHeight() {
      if (!('ResizeObserver' in window)) return;
      var group = this.closest('.quantity_group');
      var btn = group && group.querySelector('.add--to--cart');
      if (!btn) return;

      var self = this;
      var apply = function () {
        if (btn.offsetHeight === 0) return;
        self.style.setProperty('--atc-height', btn.offsetHeight + 'px');
      };
      apply();
      this._heightObserver = new ResizeObserver(apply);
      this._heightObserver.observe(btn);
    }

    handleClick(event) {
      var minus = event.target.closest('[data-qty-minus]');
      var plus = event.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;

      var input = this.querySelector('input[name="quantity"]');
      if (!input) return;

      var value = parseInt(input.value, 10) || 1;
      var min = parseInt(input.min, 10) || 1;
      var max = input.max ? parseInt(input.max, 10) : Infinity;
      value = plus ? value + 1 : value - 1;
      var clamped = Math.min(max, Math.max(min, value));
      input.value = clamped;
      if (plus && value > clamped) this.warnLimit(clamped);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /* Typed values: clamp to [min, max] and tell the user why. */
    handleChange(event) {
      var input = event.target;
      if (!input.matches || !input.matches('input[name="quantity"]')) return;

      var min = parseInt(input.min, 10) || 1;
      var max = input.max ? parseInt(input.max, 10) : Infinity;
      var value = parseInt(input.value, 10);

      if (Number.isNaN(value) || value < min) {
        input.value = min;
        this.showQuantityError('textQuantityCorrect', null);
      } else if (value > max) {
        input.value = max;
        this.warnLimit(max);
      }
    }

    warnLimit(max) {
      this.showQuantityError('textQuantityError', max);
    }

    showQuantityError(key, qty) {
      var productForm = this.closest('product-form');
      if (!productForm || typeof productForm.showError !== 'function') return;
      var errorEl = productForm.getErrorElement();
      var message = errorEl && errorEl.dataset[key];
      if (!message) return;
      if (qty != null) message = message.replace('[qty]', qty);
      productForm.showError(message, true);
    }
  }

  if (!customElements.get('quantity-input')) {
    customElements.define('quantity-input', QuantityInput);
  }

  /* ── <pickup-availability> ───────────────────────────────── */
 
  class PickupAvailability extends HTMLElement {
    connectedCallback() {
      this._onClick = this._onClick || this.handleClick.bind(this);
      this.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
    }

    handleClick(event) {
      var dialog = this.querySelector('[data-pickup-dialog]');
      if (!dialog) return;

      if (event.target.closest('[data-pickup-open]')) {
        dialog.showModal();
        return;
      }
      if (event.target.closest('[data-pickup-close]')) {
        dialog.close();
        return;
      }
       
      if (event.target === dialog) {
        var rect = dialog.getBoundingClientRect();
        var outside =
          event.clientX < rect.left ||
          event.clientX > rect.right ||
          event.clientY < rect.top ||
          event.clientY > rect.bottom;
        if (outside) dialog.close();
      }
    }
  }

  if (!customElements.get('pickup-availability')) {
    customElements.define('pickup-availability', PickupAvailability);
  }

  /* ── <deferred-media> ────────────────────────────────────── */
 
  var MODEL_FOV_MAX_DEG = 30;  
  var MODEL_FOV_MIN_DEG = 7.5; 
  var MODEL_FOV_FLOOR_DEG = 6.5;  
  var MODEL_FOV_STEP_IN = 0.8;
  var MODEL_FOV_STEP_OUT = 1.25;
  var MODEL_FOV_DRIFT = 0.35; 
  var MODEL_FOV_SETTLE_MS = 600;  
  var MODEL_ZOOM_BUTTONS =
    '.shopify-model-viewer-ui__button--zoom-in, .shopify-model-viewer-ui__button--zoom-out';

  /*
   * Poster image + badge; clicking swaps in the media held in the inner template.
   */
  class DeferredMedia extends HTMLElement {
    connectedCallback() {
      this._onClick = this._onClick || this.handleClick.bind(this);
      this._onKeydown = this._onKeydown || this.handleKeydown.bind(this);
      this._onModelZoom = this._onModelZoom || this.handleModelZoom.bind(this);
      this.addEventListener('click', this._onClick);
      this.addEventListener('keydown', this._onKeydown, true);
      this.addEventListener('click', this._onModelZoom, true);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('keydown', this._onKeydown, true);
      this.removeEventListener('click', this._onModelZoom, true);
    }

    handleClick(event) {
      if (!event.target.closest('[data-deferred-media-button]')) return;
      this.loadContent();
    }

    /*
     * Capture-phase: model-viewer's camera-controls handler 
     */
    handleKeydown(event) {
      if (this.getAttribute('loaded') !== 'true') return;
      if (!this.querySelector('model-viewer')) return;

      if (event.key === 'Tab') {
        event.stopPropagation();
        return;
      }
      if (event.key === 'Escape') {
        event.stopPropagation();
        this.unloadContent();
        var poster = this.querySelector('[data-deferred-media-button]');
        if (poster) poster.focus();
      }
    }

    loadContent() {
      if (this.getAttribute('loaded') === 'true') return;
 
      var node = this.querySelector('model-viewer, video, iframe');
      if (!node) {
        var template = this.querySelector('template');
        var content = template && template.content.querySelector('model-viewer, video, iframe');
        if (!content) return;
        node = content.cloneNode(true);
        this.appendChild(node);
      }

      this.setAttribute('loaded', 'true');
      this.classList.add('swiper-no-swiping');
 
      
      var gallery = this.closest('product-media-gallery, quick-view-media');
      if (gallery && typeof gallery.pauseAllExcept === 'function') {
        gallery.pauseAllExcept(node);
      }

      if (node.tagName === 'VIDEO') { 
        if (!node.hasAttribute('tabindex')) node.setAttribute('tabindex', '0');
        var playing = node.play();
        if (playing && playing.catch) playing.catch(function () {}); 
        if (this.contains(document.activeElement) || document.activeElement === document.body) {
          node.focus({ preventScroll: true });
        }
      }

      if (node.tagName === 'IFRAME') {
        if (gallery && typeof gallery.bindIframeHandshakes === 'function') {
          gallery.bindIframeHandshakes();
        }
      }

      if (node.tagName === 'MODEL-VIEWER') {
        var self = this; 
        var keepModelFocus = function () { 
          var active = document.activeElement;
          if (active && active.closest && active.closest('.shopify-model-viewer-ui__button')) return;
          if (
            self.getAttribute('loaded') === 'true' &&
            (document.activeElement === document.body || self.contains(document.activeElement))
          ) {
            if (!node.hasAttribute('tabindex')) node.setAttribute('tabindex', '0');
            node.focus();
          }
        }; 
        var scheduleModelFocus = function () {
          requestAnimationFrame(keepModelFocus);
          setTimeout(keepModelFocus, 300);
          setTimeout(keepModelFocus, 1200);
        };
        node.addEventListener('load', scheduleModelFocus, { once: true });

        if (typeof node.dismissPoster === 'function') node.dismissPoster();
        if (this.modelViewerUI) { 
          if (typeof this.modelViewerUI.play === 'function') this.modelViewerUI.play();
          this.normalizeModelFocus(node);
          scheduleModelFocus();
        } else if (window.Shopify && window.Shopify.loadFeatures) {
          window.Shopify.loadFeatures([
            {
              name: 'model-viewer-ui',
              version: '1.0',
              onLoad: function (errors) {
                if (errors || !window.Shopify.ModelViewerUI) return;
                self.modelViewerUI = new window.Shopify.ModelViewerUI(node);
                if (typeof node.dismissPoster === 'function') node.dismissPoster();
                self.initModelFovBounds(node);
                self.normalizeInjectedButtons();
                self.normalizeModelFocus(node);

                if (self.getAttribute('loaded') === 'true') {
                  self.classList.add('swiper-no-swiping');
                  if (typeof self.modelViewerUI.play === 'function') self.modelViewerUI.play();
                  scheduleModelFocus();
                }
              },
            },
          ]);
        }
      }
    }
 
    /*
     * Reverses loadContent() — used by the thumbnail 3D on/off toggle.
     * Removing [loaded] re-shows the poster (and hides model-viewer) via CSS.
     */
    unloadContent() {
      if (this.getAttribute('loaded') !== 'true') return;
      var node = this.querySelector('model-viewer, video, iframe');
      this.removeAttribute('loaded');
      this.classList.remove('swiper-no-swiping');
      if (this.modelViewerUI && typeof this.modelViewerUI.pause === 'function') {
        this.modelViewerUI.pause();
      } 
      this._modelFramedFov = MODEL_FOV_MAX_DEG;
      if (node && node.tagName === 'VIDEO' && !node.paused) node.pause();
    }

    pauseModel() {
      this.classList.remove('swiper-no-swiping');
      if (this.modelViewerUI && typeof this.modelViewerUI.pause === 'function') {
        this.modelViewerUI.pause();
      }
      this._modelFramedFov = MODEL_FOV_MAX_DEG;
    }
    resumeModel() {
      if (this.getAttribute('loaded') !== 'true') return;
      this.classList.add('swiper-no-swiping');
      if (this.modelViewerUI && typeof this.modelViewerUI.play === 'function') { 
        var prevFocus = document.activeElement;
        this.modelViewerUI.play();
        if (prevFocus && prevFocus !== document.body && document.activeElement !== prevFocus) {
          prevFocus.focus({ preventScroll: true });
        }
      }
    }

    normalizeInjectedButtons() {
      this.querySelectorAll('button:not([type])').forEach(function (button) {
        button.type = 'button';
      });
    }
  
    initModelFovBounds(node) {
      if (!node) return;
      this._modelFramedFov = MODEL_FOV_MAX_DEG;
      this._modelCamCeiling = null;
      var self = this;
      var capture = function () {
        if (typeof node.getFieldOfView !== 'function') return;
        var fov = node.getFieldOfView();
        if (isFinite(fov) && fov > 0) self._modelCamCeiling = fov;
      };
      if (node.loaded) capture();
      else node.addEventListener('load', capture, { once: true });
    }

    
    ensureModelFovFloor(node) {
      if (this._modelFovFloorSet) return;
      this._modelFovFloorSet = true;
      node.setAttribute('min-field-of-view', MODEL_FOV_FLOOR_DEG + 'deg');
    }

   
    handleModelZoom(event) {
      var target = event.target;
      var button = target && target.closest ? target.closest(MODEL_ZOOM_BUTTONS) : null;
      if (!button) return;
      event.stopPropagation();
      var node = this.querySelector('model-viewer');
      if (!node) return;
      this.stepModelFov(
        node,
        button.classList.contains('shopify-model-viewer-ui__button--zoom-in')
          ? MODEL_FOV_STEP_IN
          : MODEL_FOV_STEP_OUT
      );
    }

    stepModelFov(node, factor) {
      this.ensureModelFovFloor(node);
      var current = typeof this._modelFramedFov === 'number' ? this._modelFramedFov : null;
      var settled = Date.now() - (this._modelFovWrittenAt || 0) > MODEL_FOV_SETTLE_MS;
      if (current === null) {
        var initial = this.readModelFramedFov(node);
        current = initial === null ? MODEL_FOV_MAX_DEG : initial;
      } else if (settled) {
        
        var live = this.readModelFramedFov(node);
        if (live !== null && Math.abs(live - current) > current * MODEL_FOV_DRIFT) current = live;
      } 
      var next = Math.min(Math.max(current * factor, MODEL_FOV_MIN_DEG), MODEL_FOV_MAX_DEG);
      if (Math.abs(next - current) < 0.01) return;
      this._modelFramedFov = next;
      this._modelFovWrittenAt = Date.now();
      node.fieldOfView = next + 'deg';
      this.announceModelZoom(next);
    }
 
    readModelFramedFov(node) {
      if (typeof node.getFieldOfView !== 'function') return null;
      var ceiling = this._modelCamCeiling;
      if (!ceiling || !isFinite(ceiling) || ceiling <= 0) return null;
      var halfRad = Math.PI / 360;
      var inflatedNow = node.getFieldOfView();
      if (!isFinite(inflatedNow) || inflatedNow <= 0) return null;
      var inflation = Math.tan(ceiling * halfRad) / Math.tan(MODEL_FOV_MAX_DEG * halfRad);
      if (!isFinite(inflation) || inflation <= 0) return null;
      return Math.atan(Math.tan(inflatedNow * halfRad) / inflation) / halfRad;
    }

    announceModelZoom(framedFov) {
      var ui = this.modelViewerUI;
      var live = ui && ui.elements ? ui.elements.zoomLevel : null;
      if (!live) return;
      var span = MODEL_FOV_MAX_DEG - MODEL_FOV_MIN_DEG;
      live.textContent = Math.round((100 * (MODEL_FOV_MAX_DEG - framedFov)) / span) + '%';
    }

    normalizeModelFocus(node) {
      if (!node || !node.shadowRoot) return;
      var inner = node.shadowRoot.querySelector('[tabindex="1"]');
      if (inner) inner.setAttribute('tabindex', '0');
    }
  }

  if (!customElements.get('deferred-media')) {
    customElements.define('deferred-media', DeferredMedia);
  }

  /* ── <product-media-gallery> ─────────────────────────────── */

  class ProductMediaGallery extends HTMLElement {
    connectedCallback() {
      this._desktopMql = window.matchMedia('(min-width: 990px)');
      this._onBreakpoint = this._onBreakpoint || this.handleBreakpoint.bind(this);
      this._onThumbClick = this._onThumbClick || this.handleThumbActivate.bind(this);
      this._onThumbFocus = this._onThumbFocus || this.handleThumbFocus.bind(this);
      this._onPlayCapture = this._onPlayCapture || this.handleNativePlay.bind(this);
      this._onVolumeCapture = this._onVolumeCapture || this.handleNativeVolumeChange.bind(this);
      this._onMessage = this._onMessage || this.handlePlayerMessage.bind(this);
      this._desktopMql.addEventListener('change', this._onBreakpoint);
      this.addEventListener('focusin', this._onThumbFocus);
      this.addEventListener('click', this._onThumbClick, true);
      this.addEventListener('play', this._onPlayCapture, true);
      this.addEventListener('volumechange', this._onVolumeCapture, true);
      window.addEventListener('message', this._onMessage);
      this.bindIframeHandshakes();
      this.initZoom();
      this.ensureVideoFocusable();

      if (this.isSliderMode()) {
        var self = this;
        waitForSwiper(function () {
          self.initSlider();
        });
      } else {
        this.syncStaticVideos();
      }
    }

    disconnectedCallback() {
      this._desktopMql.removeEventListener('change', this._onBreakpoint);
      this.removeEventListener('click', this._onThumbClick, true);
      this.removeEventListener('focusin', this._onThumbFocus);
      this.removeEventListener('play', this._onPlayCapture, true);
      this.removeEventListener('volumechange', this._onVolumeCapture, true);
      window.removeEventListener('message', this._onMessage);
      this.destroySlider();
      this.destroyZoom();
      this.unobserveThumbsHeight();
    }

     
    ensureVideoFocusable() {
      this.querySelectorAll('.product-media-item video').forEach(function (video) {
        if (!video.hasAttribute('tabindex')) video.setAttribute('tabindex', '0');
      });
    }

    pauseAllExcept(exceptEl) {
      this.querySelectorAll('.product-media-item video').forEach(function (video) {
        if (video !== exceptEl && !video.paused) video.pause();
      });
      this.querySelectorAll('.product-media-item iframe').forEach(function (iframe) {
        if (iframe !== exceptEl) controlExternalVideo(iframe, 'pause');
      }); 
      this.querySelectorAll('.product-media-item deferred-media[loaded="true"]').forEach(function (deferred) {
        if (exceptEl && deferred.contains(exceptEl)) return;
        if (typeof deferred.pauseModel === 'function') deferred.pauseModel();
      });
    }

    handleNativePlay(event) {
      var video = event.target;
      if (!video || video.tagName !== 'VIDEO') return;
      if (!video.closest('.product-media-item')) return; 
      if (this.dataset.autoplayVideos === 'true' && video.muted) return;
      this.pauseAllExcept(video);
    }

     handleNativeVolumeChange(event) {
      var video = event.target;
      if (!video || video.tagName !== 'VIDEO') return;
      if (!video.closest('.product-media-item')) return;
      if (!video.muted && !video.paused) this.pauseAllExcept(video);
    }
    bindIframeHandshakes() {
      var self = this;
      this.querySelectorAll('.product-media-item iframe').forEach(function (iframe) {
        if (iframe.dataset.videoSyncBound) return;
        iframe.dataset.videoSyncBound = 'true';
        iframe.addEventListener('load', function () {
          self.sendIframeHandshake(iframe);
          if (self.isSliderMode()) self.syncSlideMedia();
        });
        self.sendIframeHandshake(iframe); 
        var attempts = 0;
        var retry = function () {
          if (iframe.dataset.playerReady === 'true' || attempts >= 10) return;
          if (!iframe.isConnected) return;
          attempts += 1;
          self.sendIframeHandshake(iframe);
          setTimeout(retry, 500);
        };
        setTimeout(retry, 500);
      });
    }

    sendIframeHandshake(iframe) {
      var src = iframe.src || '';
      var win = iframe.contentWindow;
      if (!win) return;
      try {
        if (src.indexOf('youtube.com') > -1 || src.indexOf('youtube-nocookie.com') > -1) {
          win.postMessage(
            JSON.stringify({ event: 'listening', id: 'pmg-' + ++playerUid, channel: 'widget' }),
            '*'
          );
        } else if (src.indexOf('vimeo.com') > -1) {
          win.postMessage(JSON.stringify({ method: 'addEventListener', value: 'play' }), '*');
          win.postMessage(JSON.stringify({ method: 'addEventListener', value: 'pause' }), '*');
          win.postMessage(JSON.stringify({ method: 'addEventListener', value: 'finish' }), '*');
          win.postMessage(JSON.stringify({ method: 'addEventListener', value: 'volumechange' }), '*');
        }
      } catch (error) {
        /* cross-origin hiccup — ignore */
      }
    }

    handlePlayerMessage(event) {
      var iframes = this.querySelectorAll('.product-media-item iframe');
      var sender = null;
      iframes.forEach(function (iframe) {
        if (iframe.contentWindow === event.source) sender = iframe;
      });
      if (!sender) return;
 
      if (sender.dataset.playerReady !== 'true') {
        sender.dataset.playerReady = 'true';
        var pending = sender.dataset.pendingCommand;
        if (pending) {
          delete sender.dataset.pendingCommand;
          controlExternalVideo(sender, pending);
        }
      }

      var data = event.data;
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (error) {
          return;
        }
      }
      if (!data || typeof data !== 'object') return;
 
      if (data.event === 'ready') this.sendIframeHandshake(sender);

      /* YouTube state 1 = playing, 2 = paused, 0 = ended; Vimeo sends named events. */
      var playing =
        (data.event === 'onStateChange' && data.info === 1) ||
        (data.event === 'infoDelivery' && data.info && data.info.playerState === 1) ||
        data.event === 'play';
      var paused =
        (data.event === 'onStateChange' && (data.info === 2 || data.info === 0)) ||
        (data.event === 'infoDelivery' &&
          data.info &&
          (data.info.playerState === 2 || data.info.playerState === 0)) ||
        data.event === 'pause' ||
        data.event === 'finish';
      if (playing) sender.dataset.playing = 'true';
      else if (paused) sender.dataset.playing = 'false';

      /* Track audibility: YouTube reports muted/volume in infoDelivery, Vimeo via volumechange. */
      if (data.event === 'infoDelivery' && data.info) {
        if (typeof data.info.muted !== 'undefined') {
          sender.dataset.muted = String(data.info.muted || data.info.volume === 0);
        } else if (typeof data.info.volume !== 'undefined') {
          sender.dataset.muted = String(data.info.volume === 0);
        }
      } else if (data.event === 'volumechange' && data.data) {
        sender.dataset.muted = String(!(data.data.volume > 0));
      }

      if (this.dataset.autoplayVideos === 'true') {
        /* Muted embeds may coexist; an audible one pauses everything else. */
        if (sender.dataset.playing === 'true' && sender.dataset.muted === 'false') {
          this.pauseAllExcept(sender);
        }
        return;
      }
      if (playing) this.pauseAllExcept(sender);
    }

    handleBreakpoint() {
      /* Slider: re-init to pick up desktop/mobile thumb direction changes. */
      if (this.dataset.layout === 'slider') {
        if (this.dataset.galleryInit === 'true') this.rebuildSlider();
        return;
      }
      /* Grid/stack: carousel below 990px, static grid/flex at/above it. */
      if (this.dataset.layout !== 'grid' && this.dataset.layout !== 'stack') return;
      var wantSlider = this.isSliderMode();
      var haveSlider = this.dataset.galleryInit === 'true';
      if (wantSlider && !haveSlider) {
        var self = this;
        waitForSwiper(function () {
          self.initSlider();
        });
      } else if (!wantSlider && haveSlider) {
        this.destroySlider();
        this.syncStaticVideos();
      }
    }

    /*
     * Thumbnails are native buttons, so Enter/Space arrive here as clicks.
     * Swiper's thumbs module does the actual slide sync; this adds the
     * media-aware part: video thumbs play/pause. 3D thumbs only navigate;
     * the viewer opens via the slide's own 3D icon button.
     */
    handleThumbActivate(event) {
      var thumb = event.target.closest('.product-gallery__thumb');
      if (!thumb || !this.contains(thumb)) return;
      var mediaId = thumb.dataset.mediaId;
      var mediaType = thumb.dataset.mediaType;
      var slide = this.querySelector(
        '[data-main-swiper] .product-media-item[data-media-id="' + mediaId + '"]'
      );
      if (!slide) return;
      var wasActive = slide.classList.contains('swiper-slide-active');
      var self = this; 
      requestAnimationFrame(function () { 
        self.setActiveMedia(mediaId);
        if (mediaType === 'video' || mediaType === 'external_video') {
          self.toggleSlideMedia(slide, mediaType, wasActive);
        }
      });
    }

    /*
     * Tabbing to an off-screen thumb makes the browser scroll the
     * overflow-hidden strip via scrollLeft/scrollTop, which fights Swiper's
     * transform-based layout. Undo that and let Swiper bring it into view.
     */
    handleThumbFocus(event) {
      var thumb = event.target.closest('.product-gallery__thumb');
      if (thumb) {
        var thumbsEl = this.querySelector('[data-thumbs-swiper]');
        if (thumbsEl) {
          thumbsEl.scrollLeft = 0;
          thumbsEl.scrollTop = 0;
        }
        if (this.thumbsInstance) {
          var slides = Array.prototype.slice.call(this.thumbsInstance.slides);
          var index = slides.indexOf(thumb);
          if (index > -1) this.thumbsInstance.slideTo(index);
        }
        return;
      }

       
      if (!this.isSliderMode()) return;
      if (event.target.tagName === 'MODEL-VIEWER') return;
      var mainEl = event.target.closest('[data-main-swiper]');
      if (!mainEl) return; 
      mainEl.scrollLeft = 0;
      mainEl.scrollTop = 0;
      var slide = event.target.closest('.swiper-slide');
      if (!slide || slide.classList.contains('swiper-slide-active')) return;
      if (slide.dataset.mediaId) this.setActiveMedia(slide.dataset.mediaId);
    }

    toggleSlideMedia(slide, mediaType, wasActive) {
      var deferred = slide.querySelector('deferred-media');

      if (deferred && deferred.getAttribute('loaded') !== 'true') {
        deferred.loadContent();
        return;
      }

      if (mediaType === 'video') {
        var video = slide.querySelector('video');
        if (!video) return;
        if (!wasActive || video.paused) { 
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
        } else {
          video.pause();
        }
        return;
      }

      /* external_video */
      var iframe = slide.querySelector('iframe');
      if (!iframe) return;
      if (!wasActive || iframe.dataset.playing !== 'true') {
        controlExternalVideo(iframe, 'play');
      } else {
        controlExternalVideo(iframe, 'pause');
      }
    }

    /* Effective layout: slider is always a carousel; grid/stack become a
       carousel only below the 990px desktop breakpoint. */
    isSliderMode() {
      if (this.dataset.layout === 'slider') return true;
      if (this.dataset.layout === 'grid' || this.dataset.layout === 'stack') {
        return !this._desktopMql.matches;
      }
      return false;
    }

    initSlider() {
      if (!window.Swiper || this.dataset.galleryInit === 'true') return;
      var mainEl = this.querySelector('[data-main-swiper]');
      if (!mainEl) return;
      this.dataset.galleryInit = 'true';

      var gap = parseInt(this.dataset.gap, 10) || 0;
      var thumbsEl = this.querySelector('[data-thumbs-swiper]');
      var thumbsInstance = null;

      if (thumbsEl) {
        var vertical = this.dataset.thumbPosition === 'left' && this._desktopMql.matches; 
        var thumbsConfig = {
          direction: vertical ? 'vertical' : 'horizontal',
          slidesPerView: vertical ? 'auto' : 4,
          spaceBetween: 8,
          freeMode: true,
          watchSlidesProgress: true,
        };
        if (!vertical) {
          thumbsConfig.breakpoints = {
            768: { slidesPerView: 5 },
            992: { slidesPerView: 6 },
          };
        }
        thumbsInstance = new Swiper(thumbsEl, thumbsConfig);
      }

      var config = {
        slidesPerView: 1,
        spaceBetween: gap,
        watchOverflow: true,
        autoHeight: this.dataset.ratio === 'adapt',
        speed: prefersReducedMotion.matches ? 0 : 300, 
        a11y: { scrollOnFocus: false },
        on: {
          slideChangeTransitionStart: this.handleSlideChangeStart.bind(this),
          slideChange: this.handleSlideChange.bind(this), 
          slideChangeTransitionEnd: this.syncSlideMedia.bind(this),
        },
      };
 
      var slidesPerView = parseFloat(this.dataset.slidesPerView) || 1;
      if (slidesPerView > 1) {
        config.breakpoints = { 990: { slidesPerView: slidesPerView } };
        config.autoHeight = false;  
      }

      var prevEl = this.querySelector('[data-gallery-prev]');
      var nextEl = this.querySelector('[data-gallery-next]');
      if (prevEl && nextEl) {
        config.navigation = { prevEl: prevEl, nextEl: nextEl };
      }
      var paginationEl = this.querySelector('[data-gallery-pagination]');
      if (paginationEl) {
        config.pagination = { el: paginationEl, clickable: true }; 
        if (paginationEl.dataset.paginationStyle === 'bold') {
          config.pagination.renderBullet = function (index, className) {
            return (
              '<span class="' + className + ' custom-bullet">' +
              '<svg class="progress-ring" viewBox="0 0 34 34" aria-hidden="true">' +
              '<circle class="progress-ring-bg" cx="17" cy="17" r="16"></circle>' +
              '<circle class="progress-ring-fill" cx="17" cy="17" r="16"></circle>' +
              '</svg>' +
              '<span class="bullet-dot"></span>' +
              '</span>'
            );
          };
        }
      }
      if (thumbsInstance) {
        config.thumbs = { swiper: thumbsInstance };
      }

      this.swiperInstance = new Swiper(mainEl, config);
      this.thumbsInstance = thumbsInstance;
      this.handleSlideChange();
      this.observeThumbsHeight(mainEl);
    }

     
    updateThumbsHeight() {
      if (this.dataset.thumbPosition !== 'left' || !this._desktopMql.matches) {
        this.style.removeProperty('--gallery-media-height');
        return;
      }
      var mainEl = this.querySelector('[data-main-swiper]');
      if (!mainEl) return; 
      var media = mainEl.querySelector('.swiper-slide-active img, .swiper-slide-active video')
        || mainEl.querySelector('img, video');
      var height = media ? media.getBoundingClientRect().height : 0;
      if (height <= 0) return;
      this.style.setProperty('--gallery-media-height', Math.round(height) + 'px');
      if (this.thumbsInstance) this.thumbsInstance.update();
    }

    observeThumbsHeight(mainEl) {
      var self = this;
      this.updateThumbsHeight(); 
      if (!this._onMediaLoad) {
        this._onMediaLoad = function () {
          self.updateThumbsHeight();
        };
      }
      mainEl.addEventListener('load', this._onMediaLoad, true);
      this._thumbsHeightMainEl = mainEl;

      if (!window.ResizeObserver || this._thumbsHeightObserver) return;
      this._thumbsHeightObserver = new ResizeObserver(function () {
        self.updateThumbsHeight();
      });
      this._thumbsHeightObserver.observe(mainEl);
    }

    unobserveThumbsHeight() {
      if (this._thumbsHeightObserver) {
        this._thumbsHeightObserver.disconnect();
        this._thumbsHeightObserver = null;
      }
      if (this._thumbsHeightMainEl && this._onMediaLoad) {
        this._thumbsHeightMainEl.removeEventListener('load', this._onMediaLoad, true);
        this._thumbsHeightMainEl = null;
      }
      this.style.removeProperty('--gallery-media-height');
    }

    destroySlider() {
      this.unobserveThumbsHeight();
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
      if (this.thumbsInstance) {
        this.thumbsInstance.destroy(true, true);
        this.thumbsInstance = null;
      }
      delete this.dataset.galleryInit;
    }

    rebuildSlider(activeMediaId) {
      var previousIndex = this.swiperInstance ? this.swiperInstance.activeIndex : 0;
      this.destroySlider();
      this.initSlider();
      if (!this.swiperInstance) return;
      if (activeMediaId) {
        this.setActiveMedia(activeMediaId);
      } else {
        this.swiperInstance.slideTo(previousIndex, 0);
      }
    }
 
    refresh() {
      /* Stop everything first — slides are about to be recreated, which would
         otherwise orphan a playing video/model (audible in the theme editor). */
      this.pauseAllExcept(null);
      this._slideStore = this.querySelector('[data-slide-store]');
      this._orderedSlides = null;
      this.destroySlider();
      this.bindIframeHandshakes();
      if (this.isSliderMode()) {
        var self = this;
        waitForSwiper(function () {
          self.initSlider();
        });
      } else {
        this.syncStaticVideos();
      }
    }

    handleSlideChange() {
      this.updateCounter();
      this.updateThumbAria();
      this.syncSlideMedia();
      this.updateThumbsHeight();
      this.clearLenses();
    }

    
    handleSlideChangeStart() {
      var active = this.querySelector('[data-main-swiper] .swiper-slide-active');
      var node = active ? active.querySelector('model-viewer, video, iframe') : null;
      this.pauseAllExcept(node);
    }

    clearLenses() {
      var open = this.querySelectorAll('.is-lensing');
      for (var i = 0; i < open.length; i++) open[i].classList.remove('is-lensing');
    }

    updateThumbAria() {
      var activeSlide = this.querySelector('[data-main-swiper] .swiper-slide-active');
      var activeId = activeSlide ? activeSlide.dataset.mediaId : null;
      this.querySelectorAll('.product-gallery__thumb').forEach(function (thumb) {
        if (thumb.dataset.mediaId === activeId) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    }

    updateCounter() {
      var counter = this.querySelector('[data-media-counter]');
      if (!counter || !this.swiperInstance) return;
      var total = this.swiperInstance.slides.length;
      counter.textContent = this.swiperInstance.activeIndex + 1 + ' / ' + total;
    }

    syncSlideMedia() {
      var autoplay = this.dataset.autoplayVideos === 'true';
      var slides = this.querySelectorAll('[data-main-swiper] .swiper-slide'); 
      var multiUp = (parseFloat(this.dataset.slidesPerView) || 1) > 1;
      this.bindIframeHandshakes();
      slides.forEach(function (slide) {
        var active = slide.classList.contains('swiper-slide-active');
        if (multiUp && slide.classList.contains('swiper-slide-visible')) active = true;

        var video = slide.querySelector('video');
        if (video) {
          if (active && autoplay) {
            playHostedVideo(video);
          } else if (!active && !video.paused) {
            video.pause();
          }
        }

        var iframe = slide.querySelector('iframe');
        if (iframe) {
          if (active && autoplay) {
            controlExternalVideo(iframe, 'play');
          } else if (!active) {
            controlExternalVideo(iframe, 'pause');
          }
        }
 
        if (slide.dataset.mediaType === 'model') {
          var deferred = slide.querySelector('deferred-media[loaded="true"]');
          if (deferred) {
            if (active) deferred.resumeModel();
            else deferred.pauseModel();
          }
        }
      });
    }
 
    syncStaticVideos() {
      if (this.isSliderMode()) return;
      var autoplay = this.dataset.autoplayVideos === 'true';
      this.querySelectorAll('.product-media-item video').forEach(function (video) {
        if (autoplay) {
          playHostedVideo(video);
        } else if (!video.paused) {
          video.pause();
        }
      });
      this.querySelectorAll('.product-media-item iframe').forEach(function (iframe) {
        controlExternalVideo(iframe, autoplay ? 'play' : 'pause');
      });
    }

    onVariantChange(variant) {
      if (this.dataset.hideVariantMedia === 'true' && variant) {
        this.filterMedia(variant);
        return;
      }
      if (variant && variant.featured_media_id) {
        this.setActiveMedia(String(variant.featured_media_id));
      }
    }

     
    filterMedia(variant) {
      var featuredMediaId = variant.featured_media_id ? String(variant.featured_media_id) : null;
      var items = Array.prototype.slice.call(
        this.querySelectorAll('.product-media-item[data-media-id]')
      );
      var hiddenMediaIds = [];
      var isExcluded = function (el) {
        return el.dataset.variantMedia === 'true' && el.dataset.mediaId !== featuredMediaId;
      };

      if (!this.isSliderMode()) {
        items.forEach(function (item) {
          item.hidden = isExcluded(item);
        });
        if (featuredMediaId) {
          this.setActiveMedia(featuredMediaId);
        }
        return;
      }

      if (!this._slideStore) {
        this._slideStore = document.createElement('div');
        this._slideStore.hidden = true;
        this._slideStore.setAttribute('data-slide-store', '');
        this.appendChild(this._slideStore);
      }
      if (!this._orderedSlides) {
        this._orderedSlides = items;
      }

      var wrapper = this.querySelector('[data-main-swiper] .swiper-wrapper');
      if (!wrapper) return;
      var store = this._slideStore;

      this._orderedSlides.forEach(function (slide) {
        if (isExcluded(slide)) {
          hiddenMediaIds.push(slide.dataset.mediaId);
          store.appendChild(slide);
        } else {
          wrapper.appendChild(slide);
        }
      });

      this.querySelectorAll('.product-gallery__thumb').forEach(function (thumb) {
        thumb.hidden = hiddenMediaIds.indexOf(thumb.dataset.mediaId) !== -1;
      });

      this.rebuildSlider(featuredMediaId);
    }
 

    initZoom() {
      var mode = this.dataset.zoomType;
      if (mode !== 'inner' && mode !== 'lens' && mode !== 'lightbox') return;

      this._finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
      this._onZoomClick = this._onZoomClick || this.handleZoomClick.bind(this);
      this.addEventListener('click', this._onZoomClick);

      if (mode === 'inner' || mode === 'lens') {
        this._onZoomEnter = this._onZoomEnter || this.handleZoomEnter.bind(this);
        this._onZoomMove = this._onZoomMove || this.handleZoomMove.bind(this);
        this._onZoomLeave = this._onZoomLeave || this.handleZoomLeave.bind(this);
        this._onZoomWarm = this._onZoomWarm || this.handleZoomWarm.bind(this);
        this.addEventListener('pointerover', this._onZoomEnter);
        this.addEventListener('pointermove', this._onZoomMove);
        this.addEventListener('pointerout', this._onZoomLeave);
        this.addEventListener('pointerenter', this._onZoomWarm);
      }
    }

    destroyZoom() {
      if (this._onZoomClick) this.removeEventListener('click', this._onZoomClick);
      if (this._onZoomEnter) {
        this.removeEventListener('pointerover', this._onZoomEnter);
        this.removeEventListener('pointermove', this._onZoomMove);
        this.removeEventListener('pointerout', this._onZoomLeave);
        this.removeEventListener('pointerenter', this._onZoomWarm);
      }
      var lenses = this.querySelectorAll('.product-media-item__lens');
      for (var i = 0; i < lenses.length; i++) lenses[i].remove();
      this.closeLightbox(true);
    } 
    pointerZoomOk() {
      return !!(this._finePointer && this._finePointer.matches && this._desktopMql.matches);
    }

    innerZoomAvailable() {
      return this.dataset.zoomType === 'inner' && this.pointerZoomOk();
    }

    lensAvailable() {
      return this.dataset.zoomType === 'lens' && this.pointerZoomOk();
    }

    /* One lens per trigger, created lazily on first hover. */
    ensureLens(trigger) {
      var lens = trigger.querySelector('.product-media-item__lens');
      if (lens) return lens;
      lens = document.createElement('span');
      lens.className = 'product-media-item__lens';
      lens.setAttribute('aria-hidden', 'true');
      trigger.appendChild(lens);
      return lens;
    }

    
    preloadZoom(trigger) {
      var hiRes = trigger.dataset.zoomSrc;
      if (!hiRes || trigger.dataset.zoomLoaded) return;
      trigger.dataset.zoomLoaded = 'true';
      var self = this;
      var preload = new Image();
      preload.onload = function () {
        trigger.dataset.zoomReady = 'true';
        if (self.lensAvailable()) {
          var lens = trigger.querySelector('.product-media-item__lens');
          if (lens && trigger.classList.contains('is-lensing')) {
            lens.style.backgroundImage = 'url("' + hiRes + '")';
          }
        } else if (self.innerZoomAvailable()) {
          var image = trigger.querySelector('.product-media-item__media');
          if (image) {
            image.src = hiRes;
            image.removeAttribute('srcset');
            image.removeAttribute('sizes');
          }
        }
      };
      preload.src = hiRes;
    }
 
    handleZoomWarm() {
      if (!this.innerZoomAvailable() && !this.lensAvailable()) return;
      var trigger =
        this.querySelector('.swiper-slide-active [data-zoom-trigger]') ||
        this.querySelector('[data-zoom-trigger]');
      if (trigger) this.preloadZoom(trigger);
    }

    handleZoomEnter(event) {
      var isLens = this.lensAvailable();
      if (!this.innerZoomAvailable() && !isLens) return;
      var trigger = event.target.closest('[data-zoom-trigger]');
      if (!trigger || !this.contains(trigger)) return;
      if (trigger.contains(event.relatedTarget)) return;

      var image = trigger.querySelector('.product-media-item__media');
      if (!image) return;

      var hiRes = trigger.dataset.zoomSrc;
      this.preloadZoom(trigger);

      if (isLens) {
        var lens = this.ensureLens(trigger); 
        var lensSrc = trigger.dataset.zoomReady === 'true' && hiRes
          ? hiRes
          : image.currentSrc || image.src;
        lens.style.backgroundImage = 'url("' + lensSrc + '")';
        trigger.classList.add('is-lensing');
        this.moveLens(trigger, lens, event);
        return;
      }

      trigger.classList.add('is-zoomed');
    }

    handleZoomMove(event) {
      var isLens = this.lensAvailable();
      if (!this.innerZoomAvailable() && !isLens) return;
      var trigger = event.target.closest('[data-zoom-trigger]');
      if (!trigger) return;

      if (isLens) {
        if (!trigger.classList.contains('is-lensing')) return;
        var lens = trigger.querySelector('.product-media-item__lens');
        if (lens) this.moveLens(trigger, lens, event);
        return;
      }

      if (!trigger.classList.contains('is-zoomed')) return;
      var rect = trigger.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var x = ((event.clientX - rect.left) / rect.width) * 100;
      var y = ((event.clientY - rect.top) / rect.height) * 100;
      trigger.style.setProperty('--zoom-x', Math.min(100, Math.max(0, x)) + '%');
      trigger.style.setProperty('--zoom-y', Math.min(100, Math.max(0, y)) + '%');
    }
 
    moveLens(trigger, lens, event) {
      var rect = trigger.getBoundingClientRect();
      if (!rect.width || !rect.height) return;

      var size = parseFloat(this.dataset.lensSize) || 180;
      var scale = parseFloat(this.dataset.lensScale) || 2.5;
      var half = size / 2;

      /* Cursor position within the image, clamped so the lens never shows dead space. */
      var cx = Math.min(rect.width, Math.max(0, event.clientX - rect.left));
      var cy = Math.min(rect.height, Math.max(0, event.clientY - rect.top));

      lens.style.width = size + 'px';
      lens.style.height = size + 'px';
      lens.style.transform = 'translate(' + (cx - half) + 'px,' + (cy - half) + 'px)';
      lens.style.backgroundSize = rect.width * scale + 'px ' + rect.height * scale + 'px';
      lens.style.backgroundPosition = -(cx * scale - half) + 'px ' + -(cy * scale - half) + 'px';
    }

    handleZoomLeave(event) {
      var trigger = event.target.closest('[data-zoom-trigger]');
      if (!trigger) return;
      if (trigger.contains(event.relatedTarget)) return;
      trigger.classList.remove('is-zoomed');
      trigger.classList.remove('is-lensing');
      trigger.style.removeProperty('--zoom-x');
      trigger.style.removeProperty('--zoom-y');
    }

    handleZoomClick(event) {
      var trigger = event.target.closest('[data-zoom-trigger]');
      if (!trigger || !this.contains(trigger)) return; 
      if (this.innerZoomAvailable() || this.lensAvailable()) return;
      event.preventDefault();
      this.openLightbox(trigger);
    }
 
    zoomableTriggers() {
      var scope = this.querySelector('[data-main-swiper] .swiper-wrapper') || this;
      return Array.prototype.slice.call(scope.querySelectorAll('[data-zoom-trigger]')).filter(
        function (trigger) {
          var slide = trigger.closest('.product-media-item');
          return !slide || !slide.hidden;
        }
      );
    }

    openLightbox(trigger) {
      var triggers = this.zoomableTriggers();
      var startIndex = Math.max(0, triggers.indexOf(trigger));
      var self = this;

      this._zoomReturnFocus = trigger;
      this.buildLightbox(triggers, startIndex);

      waitForSwiper(function () {
        self.initLightboxSwiper(startIndex);
      });
    }

    buildLightbox(triggers, startIndex) {
      this.closeLightbox(true);
 
      var strings = {
        zoom: this.dataset.zoomLabel || 'Zoomed product image',
        close: this.dataset.closeLabel || (window.themeStrings || {}).close || 'Close',
        previous: this.dataset.prevLabel || 'Previous',
        next: this.dataset.nextLabel || 'Next',
      };
      var overlay = document.createElement('div');
      overlay.className = 'product-media-lightbox';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-label', strings.zoom);

      var slidesMarkup = triggers
        .map(function (trigger) {
          var image = trigger.querySelector('.product-media-item__media');
          var alt = image ? image.getAttribute('alt') || '' : '';
          var src = trigger.dataset.zoomSrc || (image ? image.currentSrc || image.src : '');
          return (
            '<div class="swiper-slide product-media-lightbox__slide">' +
            '<div class="swiper-zoom-container">' +
            '<img class="product-media-lightbox__img" src="' +
            src.replace(/"/g, '&quot;') +
            '" alt="' +
            alt.replace(/"/g, '&quot;') +
            '">' +
            '</div></div>'
          );
        })
        .join('');

      var multiple = triggers.length > 1;
      overlay.innerHTML =
        '<div class="product-media-lightbox__backdrop" data-lightbox-close></div>' +
        '<button type="button" class="product-media-lightbox__close close-btn" data-lightbox-close ' +
        'aria-label="' +
        strings.close +
        '">' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
        'stroke-width="2" stroke-linecap="round" aria-hidden="true">' +
        '<line x1="18" y1="6" x2="6" y2="18"></line>' +
        '<line x1="6" y1="6" x2="18" y2="18"></line></svg></button>' +
        '<div class="product-media-lightbox__swiper swiper" data-lightbox-swiper>' +
        '<div class="swiper-wrapper">' +
        slidesMarkup +
        '</div>' +
        (multiple
          ? '<button type="button" class="btn btn-primary product-media-lightbox__arrow product-media-lightbox__arrow--prev" data-lightbox-prev aria-label="' +
            strings.previous +
            '">' +
            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg></button>' +
            '<button type="button" class="btn btn-primary product-media-lightbox__arrow product-media-lightbox__arrow--next" data-lightbox-next aria-label="' +
            strings.next +
            '">' +
            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg></button>'
          : '') +
        '</div>';

      document.body.appendChild(overlay);
      document.body.classList.add('overflow-hidden');
      this._lightbox = overlay;

      this._onLightboxClick = this._onLightboxClick || this.handleLightboxClick.bind(this);
      this._onLightboxKeydown = this._onLightboxKeydown || this.handleLightboxKeydown.bind(this);
      overlay.addEventListener('click', this._onLightboxClick);
      document.addEventListener('keydown', this._onLightboxKeydown);

      var closeButton = overlay.querySelector('.product-media-lightbox__close');
      if (closeButton) closeButton.focus();
    }

    initLightboxSwiper(startIndex) {
      if (!this._lightbox || !window.Swiper) return;
      var element = this._lightbox.querySelector('[data-lightbox-swiper]');
      if (!element) return;

      this.lightboxInstance = new window.Swiper(element, {
        initialSlide: startIndex,
        speed: prefersReducedMotion.matches ? 0 : 300,
        zoom: { maxRatio: 3, toggle: true },
        keyboard: { enabled: true },
        navigation: {
          prevEl: this._lightbox.querySelector('[data-lightbox-prev]'),
          nextEl: this._lightbox.querySelector('[data-lightbox-next]'),
        },
      });
    }

    handleLightboxClick(event) {
      if (event.target.closest('[data-lightbox-close]')) {
        event.preventDefault();
        this.closeLightbox();
      }
    }

    handleLightboxKeydown(event) {
      if (!this._lightbox) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        this.closeLightbox();
        return;
      }
      if (event.key !== 'Tab') return;
 
      var focusable = this._lightbox.querySelectorAll('button:not([disabled])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    closeLightbox(silent) {
      if (this.lightboxInstance) {
        this.lightboxInstance.destroy(true, true);
        this.lightboxInstance = null;
      }
      if (this._lightbox) {
        if (this._onLightboxClick) this._lightbox.removeEventListener('click', this._onLightboxClick);
        this._lightbox.remove();
        this._lightbox = null;
      }
      if (this._onLightboxKeydown) {
        document.removeEventListener('keydown', this._onLightboxKeydown);
      }
      document.body.classList.remove('overflow-hidden');

      if (!silent && this._zoomReturnFocus && this._zoomReturnFocus.isConnected) {
        this._zoomReturnFocus.focus();
      }
      this._zoomReturnFocus = null;
    }

    setActiveMedia(mediaId) {
      if (this.isSliderMode()) {
        if (!this.swiperInstance) return;
        var slides = Array.prototype.slice.call(this.swiperInstance.slides);
        var index = slides.findIndex(function (slide) {
          return slide.dataset.mediaId === mediaId;
        });
        if (index > -1) this.swiperInstance.slideTo(index);
        return;
      }
      var item = this.querySelector('.product-media-item[data-media-id="' + mediaId + '"]');
      if (item && !item.hidden && this._desktopMql.matches) {
        item.scrollIntoView({
          behavior: prefersReducedMotion.matches ? 'auto' : 'smooth',
          block: 'nearest',
        });
      }
    }
  }

  if (!customElements.get('product-media-gallery')) {
    customElements.define('product-media-gallery', ProductMediaGallery);
  }

  /* ── <product-tabs> ──────────────────────────────────────── */

  var tabsUid = 0;

  class ProductTabs extends HTMLElement {
    connectedCallback() {
      this.build();
    } 
    refresh() {
      var oldNav = this.querySelector('.product-tabs__nav');
      if (oldNav) oldNav.remove();
      this._built = false;
      this.build();
    }

    build() {
      if (this._built) return;
      var panels = Array.prototype.slice.call(this.querySelectorAll('[data-tab-panel]'));
      if (!panels.length) return;
      this._built = true;
      this._panels = panels;
      this._uid = ++tabsUid;

      var nav = document.createElement('div');
      nav.className = 'product-tabs__nav';
      nav.setAttribute('role', 'tablist');
      this._buttons = panels.map(
        function (panel, index) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'product-tabs__tab';
          button.id = 'ProductTab-' + this._uid + '-' + index;
          button.setAttribute('role', 'tab');
          button.textContent = panel.dataset.tabHeading || '';
          if (!panel.id) panel.id = 'ProductTabPanel-' + this._uid + '-' + index;
          button.setAttribute('aria-controls', panel.id);
          panel.setAttribute('aria-labelledby', button.id);
          var heading = panel.querySelector('[data-tab-panel-heading]');
          if (heading) heading.hidden = true;
          button.addEventListener('click', this.activate.bind(this, index));
          nav.appendChild(button);
          return button;
        }.bind(this)
      );

      nav.addEventListener('keydown', this.handleKeydown.bind(this));
      this.insertBefore(nav, this.firstChild);
      this.activate(0);
    }

    activate(index) {
      this._buttons.forEach(
        function (button, i) {
          var selected = i === index;
          button.setAttribute('aria-selected', selected ? 'true' : 'false');
          button.tabIndex = selected ? 0 : -1;
          this._panels[i].hidden = !selected;
        }.bind(this)
      );
      this._activeIndex = index;
    }

    handleKeydown(event) {
      var count = this._buttons.length;
      var next = null;
      if (event.key === 'ArrowRight') next = (this._activeIndex + 1) % count;
      else if (event.key === 'ArrowLeft') next = (this._activeIndex - 1 + count) % count;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = count - 1;
      if (next === null) return;
      event.preventDefault();
      this.activate(next);
      this._buttons[next].focus();
    }

    activatePanel(panel) {
      var index = this._panels ? this._panels.indexOf(panel) : -1;
      if (index > -1) this.activate(index);
    }
  }

  if (!customElements.get('product-tabs')) {
    customElements.define('product-tabs', ProductTabs);
  }

  /* ── Shopify XR (AR "View in your space") ────────────────── */ 
  function setupShopifyXR() {
    if (!window.ShopifyXR) { 
      document.addEventListener('shopify_xr_initialized', setupShopifyXR, { once: true });
      return;
    }

    document.querySelectorAll('[id^="ModelJson-"]').forEach(function (node) {
      try {
        window.ShopifyXR.addModels(JSON.parse(node.textContent));
      } catch (error) { 
      } 
      node.removeAttribute('id');
    });

    window.ShopifyXR.setupXRElements();
  }

  /*
   * Loads shopify-xr.js once per page when an AR button is present, then
   * hands off to setupShopifyXR(). Loading the feature alone does nothing —
   * the library does not self-initialize.
   */
  function loadShopifyXR() {
    if (!document.querySelector('[data-shopify-xr]')) return;
    if (!(window.Shopify && window.Shopify.loadFeatures)) return;

    if (window.__themeXRLoaded) { 
      setupShopifyXR();
      return;
    }

    window.__themeXRLoaded = true;
    window.Shopify.loadFeatures([
      { name: 'shopify-xr', version: '1.0', onLoad: setupShopifyXR },
    ]);
  }

  
  function preloadModelViewerUI() {
    if (!document.querySelector('model-viewer')) return;
    if (!(window.Shopify && window.Shopify.loadFeatures)) return;
    if (window.__themeModelViewerUILoaded) return;

    window.__themeModelViewerUILoaded = true;
    window.Shopify.loadFeatures([
      { name: 'model-viewer-ui', version: '1.0', onLoad: function () {} },
    ]);
  }
 
  function schedulePreloadModelViewerUI() {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(preloadModelViewerUI, { timeout: 3000 });
    } else {
      setTimeout(preloadModelViewerUI, 1000);
    }
  }

  function initDeferredFeatures() {
    loadShopifyXR();
    schedulePreloadModelViewerUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDeferredFeatures);
  } else {
    initDeferredFeatures();
  }
 
  document.addEventListener('theme:media:injected', initDeferredFeatures);

  /* ── Theme editor integration ────────────────────────────── */

  function refreshScope(scope) {
    if (!scope || !scope.querySelectorAll) return;
    ['main-product', 'product-media-gallery', 'product-tabs'].forEach(function (tag) {
      scope.querySelectorAll(tag).forEach(function (el) {
        if (typeof el.refresh === 'function') el.refresh();
      });
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    refreshScope(event.target); 
    loadShopifyXR(); 
    schedulePreloadModelViewerUI();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target || !event.target.querySelectorAll) return;
    event.target.querySelectorAll('product-media-gallery').forEach(function (gallery) {
      if (typeof gallery.destroySlider === 'function') gallery.destroySlider();
    });
  });

  document.addEventListener('shopify:block:select', function (event) {
    var panel = event.target.closest ? event.target.closest('[data-tab-panel]') : null;
    if (panel) {
      var tabs = panel.closest('product-tabs');
      if (tabs && typeof tabs.activatePanel === 'function') tabs.activatePanel(panel);
    }
  });
})();
